import React from 'react';
import { theme } from '../styles/theme';

// Riga con freccia indietro e titolo della sezione
function SubHeader({ title, onBack }) {
  return (
    <div style={styles.row}>
      <button onClick={onBack} style={styles.backArrow} aria-label="Indietro">
        ←
      </button>
      <h2 style={styles.title}>{title}</h2>
    </div>
  );
}

const styles = {
  row: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: '500px',
    marginBottom: '10px',
  },
  backArrow: {
    backgroundColor: 'transparent',
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    color: theme.colors.brand,
    padding: '0 10px 0 0',
  },
  title: {
    fontSize: '20px',
    color: theme.colors.text,
    margin: 0,
  },
};

export default SubHeader;
